// extracted by mini-css-extract-plugin
export default {"container":"Fmy9ifd","content":"dsEdn6o","message":"AIkY9uF","header":"m2JksKr TNLlZ7K london3","details":"j2eZ7P_ ZHWKoMf leavesden3"};